import React from 'react'
import Option from '@mui/joy/Option'
import ListItemDecorator from '@mui/joy/ListItemDecorator'
import SelectInFormControl from './SelectInFormControl'

const salutations = [
  { title: 'Mr.', emoji: '👨', ariaLabel: 'Mister' },
  { title: 'Miss', emoji: '👧', ariaLabel: 'Miss' },
  { title: 'Mrs.', emoji: '👩', ariaLabel: 'Missus' },
  { title: 'Ms.', emoji: '👩', ariaLabel: 'Miz' },
  { title: 'Dr.', emoji: '🩺', ariaLabel: 'Doctor' },
  { title: 'Prof.', emoji: '🎓', ariaLabel: 'Professor' },
  { title: 'Fr.', emoji: '⛪', ariaLabel: 'Father' },
  { title: 'Rev.', emoji: '⛪', ariaLabel: 'Reverend' },
  { title: 'Msgr.', emoji: '⛪', ariaLabel: 'Monsignor' },
  { title: 'Gov.', emoji: '👔', ariaLabel: 'Governor' },
  { title: 'Rep.', emoji: '👔', ariaLabel: 'Representative' },
  { title: 'Sen.', emoji: '👔', ariaLabel: 'Senator' },
  { title: 'Amb.', emoji: '🌐', ariaLabel: 'Ambassador' },
  { title: 'Pres.', emoji: '🏛️', ariaLabel: 'President' },
  { title: 'Hon.', emoji: '🎩', ariaLabel: 'Honorable' },
  { title: 'The Hon.', emoji: '🎩', ariaLabel: 'The Honorable' },
]

// const salutations = [
//   'Mr.',
//   'Miss',
//   'Mrs.',
//   'Ms.',
//   'Dr.',
//   'Fr.',
//   'Rev.',
//   'Prof.',
//   'Gov.',
//   'Rep.',
//   'Sen.',
//   'Pres.',
//   'Msgr.',
//   'Amb.',
//   'Hon.',
//   'The Hon.'
// ]

const options = salutations.map(({ title, emoji, ariaLabel }, index) => {
  return (
    <Option key={index} value={title}>
      <ListItemDecorator>
        <span role='img' aria-label={ariaLabel}>
          {emoji}
        </span>
      </ListItemDecorator>
      {title} ({ariaLabel})
    </Option>
  )
})

const SalutationSelectInFormControl = (props) => {
  return (
    <SelectInFormControl {...props}>
      {options}
    </SelectInFormControl>
  )
}

export default SalutationSelectInFormControl
